import {FC} from 'react'
import {useAuth} from '../../../modules/auth'
import {DashboardActivityFeed} from './DashboardActivityFeed'
import {DashboardLiveOperations} from './DashboardLiveOperations'
import {DashboardRecentErrors} from './DashboardRecentErrors'
import {DashboardRecentProducts} from './DashboardRecentProducts'
import './DashboardActivity.scss'

// What happens in the selected business: work in progress, the latest registrations grouped
// into batches with their send status, the errors to look at and the goods/services invoiced
// last. Every read is per business, so without one selected nothing is requested.
const DashboardActivitySection: FC = () => {
  const {currentUser} = useAuth()
  const companyId = Number(currentUser?.cpi || 0)

  if (companyId <= 0) {
    return (
      <div className='mp-sso-notice mp-sso-notice--info' role='note'>
        <i className='las la-info-circle' aria-hidden='true' />
        <div>
          <strong>یک کسب‌وکار انتخاب کنید</strong>
          <small>
            عملیات در جریان، گزارش فعالیت‌ها، خطاهای اخیر و آخرین کالا و خدمات برای کسب‌وکار
            انتخاب‌شده نمایش داده می‌شوند؛ کسب‌وکار را از بالای همین صفحه انتخاب کنید.
          </small>
        </div>
      </div>
    )
  }

  return (
    <>
      <DashboardLiveOperations companyId={companyId} />
      <section className='mp-dashboard-activity' aria-label='فعالیت‌های اخیر کسب‌وکار'>
        <DashboardActivityFeed companyId={companyId} />
        <div className='mp-dashboard-activity__side'>
          <DashboardRecentErrors companyId={companyId} />
          <DashboardRecentProducts companyId={companyId} />
        </div>
      </section>
    </>
  )
}

export {DashboardActivitySection}
